import LicenseRequestFormInputs from './licenseRequestFormInputs';
import LicenseRequestFormSettings from './licenseRequestFormSettings';

class LicenseRequestFormModel {
  constructor(data) {
    this.name = data.n;
    this.publicId = data.id;
    this.licenseRequestFormInputs = data.lrfi ? data.lrfi.map(
      (x) => new LicenseRequestFormInputs(x),
    ) : null;
    this.licenseSettings = data.ls ? new LicenseRequestFormSettings(data.ls) : [];
  }
}


export default LicenseRequestFormModel;
